import React, { useEffect, useState } from 'react';
import { Box, IconButton, TextField, Typography } from '@mui/material';
import ModeEditIcon from '@mui/icons-material/ModeEdit';

type EditableFieldProps = {
  value?: number | string | null;
  onChange: (newValue: string) => void;
  extraLabel?: string | number;
  width?: string;
};

function EditableField({ value, onChange, extraLabel = '', width = '100%' }: EditableFieldProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState<string>(value?.toString() ?? '');

  const isVisibleExtraLabel = extraLabel && Number(extraLabel) !== 0 && Number(extraLabel) !== Number(value);

  useEffect(() => {
    if (!isEditing) {
      setDraft(value?.toString() ?? '');
    }
  }, [value, isEditing]);

  const handleSave = () => {
    setIsEditing(false);
    onChange(draft);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      e.stopPropagation();
      setIsEditing(false);
      setDraft(value?.toString() ?? '');
    }
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      {isEditing ? (
        <TextField
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onBlur={handleSave}
          onKeyDown={handleKeyDown}
          autoFocus
          size="small"
          variant="standard"
          sx={{ maxWidth: width }}
        />
      ) : (
        <Box display="flex" alignItems="center" sx={{ minWidth: width, justifyContent: 'space-between' }}>
          <Typography>
            {!value && value !== 0 ? '-' : value}
            <i>{isVisibleExtraLabel ? ` (${extraLabel})` : ''}</i>
          </Typography>
          <IconButton size="small" onClick={() => setIsEditing(true)} sx={{ p: 0, ml: '4px', pb: '4px' }}>
            <ModeEditIcon fontSize="small" color="primary" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
}

export default EditableField;
